import { getUserAuditTrail } from '@appt-digital/frontend-api-lib-sheffmed'
import React, { useContext, useEffect, useState } from 'react'
import Paper from '@mui/material/Paper'
import Typography from '../../ui-library/components/Typography'
import { useFormik } from 'formik'
import { domainSchema } from '../../config/validation'
// import {
//   deleteAppUser,
//   editAppUser,
//   resetAppUser,
// } from '../../handlers/requests/users/appUsersHandler'

import { editDomain, deleteDomain } from '../../handlers/requests/sheffmed/domains'

import ConfirmationModal from '../../ui-library/components/dialogs/ConfirmationModal'
import { AlertContext } from '../../context/AlertContext'
import TextField from '../../ui-library/components/TextField'
import Dropdown from '../../ui-library/components/Dropdown'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import Button from '../../ui-library/components/Button'
import Link from '../../ui-library/components/Link'
import { FaUser } from 'react-icons/fa'
import { MdDeleteForever } from 'react-icons/md'
import { ThemeContext } from '../../ui-library/components/ThemeContext'
import DashboardContainer from '../../ui-library/components/DashboardContainer'
import TabHeader from '../../ui-library/components/TabHeader'
import { useLocation, useNavigate } from 'react-router-dom'
import toCapitalised from '../../utils/capitaliseString'


function EditDomain() {
  const [loading, setLoading] = useState(false)
  const { setAlert } = useContext(AlertContext)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmReset, setConfirmReset] = useState(false)
  const [audit, setAudit] = useState([])
  const { theme } = useContext(ThemeContext)
  const { state } = useLocation()
  const navigate = useNavigate()
  const initialEdit = {
    domain: state?.domain?.domain || '',
    paymentByInvoice: !!state?.domain?.paymentByInvoice,
    priceTier: state?.domain?.priceTier || '',
    shippingTier: state?.domain?.shippingTier || ''
  }

  const [priceTier, setPriceTier] = useState(
    {
      label: state?.domain?.priceTier,
      value: state?.domain?.priceTier,
    } || { label: 'Prices Hidden', value: 'Prices Hidden' }
  )

  const [shippingTier, setShippingTier] = useState(
    {
      label: state?.domain?.shippingTier,
      value: state?.domain?.shippingTier,
    } || { label: 'Default', value: 'Default' }
  )

  const [paymentByInvoice, setPaymentByInvoice] = useState(
    {
      label: state?.domain?.paymentByInvoice ? 'Yes' : 'No',
      value: !!state?.domain?.paymentByInvoice,
    } || { label: 'No', value: false }
  )


  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: initialEdit,
      validationSchema: domainSchema,
      onSubmit: async () => await handleEdit(),
    })
  const handleEdit = async () => {
    await editDomain(
      state?.domain?.id,
      {
        ...values,
        priceTier: priceTier?.label,
        shippingTier: shippingTier?.label,
        paymentByInvoice: paymentByInvoice?.value,
      }
    )

    // setAlert,
    setLoading(false)
    navigate('/dashboard/domains')
  }
  useEffect(() => {
    const getAuditTrail = async () => {
      const res = await getUserAuditTrail(state?.user?.id)
      setAudit(res?.data)
    }
    getAuditTrail()
  }, [])
  return (
    <>
      <DashboardContainer>
        <TabHeader
          title={'Edit Domain'}
          username={
            state?.user?.firstname !== null &&
            state?.user?.firstname !== undefined &&
            state?.user?.lastname !== null &&
            state?.user?.lastname !== undefined &&
            `${toCapitalised(state?.user?.firstname)} ${toCapitalised(
              state?.user?.lastname
            )}`
          }
        >
          <Paper style={theme?.dashboard?.container}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div>
                <Link
                  type="submit"
                  onClick={() => {
                    navigate('/dashboard/domains')
                  }}
                >
                  {`< Back`}
                </Link>
                <Typography source={'h1'} style={{ marginTop: 20 }}>Domain Details</Typography>

                <form onSubmit={handleSubmit}>

                    {/* 

                      Title
                      Summary
                      Description <TEXTAREA>
                      Photo
                      Base Price, Tier 1, Tier 2, Tier 3
                    
                    */}

                  <div
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <Typography source={'h4'} style={{ marginTop: 10 }}>Domain</Typography>
                    <TextField
                      type="domain"
                      name="domain"
                      placeholder="Domain"
                      value={values.domain}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errorType={'domain'}
                      errors={errors}
                      touched={touched}
                    />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography source={'h4'} style={{ marginTop: 10 }}>Price Tier</Typography>
                    <Dropdown
                      type="priceTier"
                      id={'priceTier'}
                      name={'priceTier'}
                      setSelected={setPriceTier}
                      onBlur={handleBlur}
                      selected={priceTier}
                      items={[
                        { label: 'Prices Hidden', value: 'Prices Hidden' },
                        { label: 'Tier One', value: 'Tier One' },
                        { label: 'Tier Two', value: 'Tier Two' },
                        { label: 'Tier Three', value: 'Tier Three' }
                      ]}
                      Icon={ArrowDropDownIcon}
                      errorType={'type'}
                      errors={errors}
                      touched={touched}
                      style={{ container: { width: '100%', marginBottom: 5 } }}
                    />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography source={'h4'} style={{ marginTop: 10 }}>Shipping Tier</Typography>
                    <Dropdown
                      type="shippingTier"
                      id={'shippingTier'}
                      name={'shippingTier'}
                      setSelected={setShippingTier}
                      onBlur={handleBlur}
                      selected={shippingTier}
                      items={[
                        { label: 'Default', value: 'Default' },
                        { label: 'Tier One', value: 'Tier One' },
                        { label: 'Tier Two', value: 'Tier Two' },
                        { label: 'Tier Three', value: 'Tier Three' }
                      ]}
                      Icon={ArrowDropDownIcon}
                      errorType={'type'}
                      errors={errors}
                      touched={touched}
                      style={{ container: { width: '100%', marginBottom: 5 } }}
                    />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography source={'h4'} style={{ marginTop: 10 }}>Payment By Invoice</Typography>
                    <Dropdown
                      type="paymentByInvoice"
                      id={'paymentByInvoice'}
                      name={'paymentByInvoice'}
                      setSelected={setPaymentByInvoice}
                      onBlur={handleBlur}
                      selected={paymentByInvoice}
                      items={[
                        { label: 'No', value: false },
                        { label: 'Yes', value: true }
                      ]}
                      Icon={ArrowDropDownIcon}
                      errorType={'type'}
                      errors={errors}
                      touched={touched}
                      style={{ container: { width: '100%', marginBottom: 5 } }}
                    />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
                    <Button type="submit">Save</Button>
                    <Button
                      onClick={() => {
                        setConfirmDelete(true)
                      }}
                      icon={MdDeleteForever}
                      icontype={'endIcon'}
                    >
                      Delete Domain
                    </Button>
                  </div>
                </form>
                <ConfirmationModal
                  onAccept={async () => {
                    await deleteDomain(state?.user?.id, setAlert)
                    navigate('/dashboard/domains')
                  }}
                  isOpen={confirmDelete}
                  onRequestClose={() => setConfirmDelete(false)}
                  type={'Delete'}
                  text={'Are you sure you wish to delete this domain?'}
                  icon={MdDeleteForever}
                />
              
              </div>
              {/* <div
                style={{
                  margin: 20,
                  borderLeft: '1px solid grey',
                  minHeight: 600,
                }}
              /> */}
              {/* <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                <Typography source={'h2'} style={{ marginTop: 30 }}>
                  Audit Trail
                </Typography>
                {!audit?.length || audit?.length < 1 ? (
                  <Typography source={'p'} style={{ marginTop: 10 }}>
                    No audit trail found
                  </Typography>
                ) : (
                  <TableContainer source={'audit'} theme={theme}>
                    <Table source={'audit'} theme={theme}>
                      <TableHead source={'audit'} theme={theme}>
                        {['Time', 'Action']?.map((header, index) => {
                          return (
                            <TableCell
                              source={'audit'}
                              key={uuid()}
                              theme={theme}
                            >
                              <Typography>{header}</Typography>
                            </TableCell>
                          )
                        })}
                      </TableHead>
                      {audit?.map((item) => {
                        return (
                          <TableRow source={'audit'} theme={theme} key={uuid()}>
                            <TableCell source={'audit'} theme={theme}>
                              {new Date(item?.updatedAt).toLocaleString()}
                            </TableCell>
                            <TableCell source={'audit'} theme={theme}>
                              {item?.description}
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </Table>
                  </TableContainer>
                )}
              </div> */}
            </div>
          </Paper>
        </TabHeader>
      </DashboardContainer>
    </>
  )
}

export default EditDomain
